var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "29.67px",
    height: "39.775px",
    viewBox: "203.607 10.361 29.67 39.775",
    enableBackground: "new 203.607 10.361 29.67 39.775",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.1978,
    y1: 195.8592,
    x2: 106.3505,
    y2: 178.2471,
    gradientTransform: "matrix(1 0 0 -1 123.345 214.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88BEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2087,
    style: {
      stopColor: "#60A7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4426,
    style: {
      stopColor: "#3B91CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6601,
    style: {
      stopColor: "#2081C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8526,
    style: {
      stopColor: "#1077BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A74BA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M218.645,10.361c10.177,0.021,17.002,9.345,13.862,19.224 c-2.432,7.652-7.398,13.776-12.649,19.671c-1.164,1.307-2.205,1.073-3.207-0.141c-4.842-5.868-9.783-11.709-12.209-19.083 C201.116,19.92,208.106,10.34,218.645,10.361z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 218.442,
    cy: 25.014,
    r: 11.32
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4D4E4E",
    d: "M225.46,21.261h-4.356c0,0-8.632,9.904-8.784,10.08c-0.073,0.083-0.022,0.112,0.037,0.121h0.963 c0,0,6.703,0,8.884,0c0.188,0,0.241-0.019,0.301-0.221C222.532,31.149,225.46,21.261,225.46,21.261z M221.925,30.913h-0.635 l0.772-2.047h-0.72l-0.868,2.047h-0.737l0.96-2.059l-0.75,0.011l-1.053,2.047h-2.278l1.32-2.047h-0.81l-1.428,2.047h-0.652 l1.504-2.047h-0.852l-1.618,2.047h-0.658l7.843-9.477h3.874L221.925,30.913z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "222.297,22.6 221.911,23.234 222.483,23.234 222.833,22.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "222.84,21.67 222.513,22.206 223.034,22.206 223.33,21.67  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3892CF",
    d: "M221.323,19.347c-0.001,0-0.001,0-0.002,0c-0.046-0.037-0.092-0.072-0.141-0.105 c-0.012-0.007-0.023-0.017-0.035-0.023c-0.332-0.217-0.726-0.347-1.152-0.347c-0.004,0-0.008,0-0.011,0 c-0.496-0.946-1.467-1.542-2.555-1.542c-0.948,0-1.833,0.469-2.37,1.239c-0.622,0.003-1.21,0.295-1.593,0.777 c-0.008,0-0.015,0-0.022,0c-1.036,0-1.88,0.843-1.88,1.88c0,1.036,0.843,1.88,1.88,1.88h2.232h3.418h2.232 c1.036,0,1.88-0.843,1.88-1.88C223.203,20.19,222.36,19.347,221.323,19.347z M221.323,22.263h-1.534h-4.813h-1.534 c-0.571,0-1.036-0.465-1.036-1.036c0-0.571,0.465-1.036,1.036-1.036c0.048,0,0.101,0.005,0.163,0.014l0.282,0.045l0.146-0.246 c0.22-0.37,0.606-0.591,1.034-0.591c0.046,0,0.096,0.004,0.158,0.012l0.282,0.037l0.14-0.247c0.363-0.642,1.045-1.04,1.781-1.04 c0.847,0,1.594,0.509,1.903,1.298l0.124,0.316c0,0,0.059-0.027,0.375-0.051c0.211-0.016,0.677,0.011,0.927,0.308l0.121,0.204 l0.282-0.045c0.062-0.01,0.115-0.014,0.163-0.014c0.571,0,1.036,0.465,1.036,1.036C222.36,21.798,221.895,22.263,221.323,22.263z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M221.323,22.263h-1.534h-4.813h-1.534c-0.571,0-1.036-0.465-1.036-1.036c0-0.571,0.465-1.036,1.036-1.036 c0.048,0,0.101,0.005,0.163,0.014l0.282,0.045l0.146-0.246c0.22-0.37,0.606-0.591,1.034-0.591c0.046,0,0.096,0.004,0.158,0.012 l0.282,0.037l0.14-0.247c0.363-0.642,1.045-1.04,1.781-1.04c0.847,0,1.594,0.509,1.903,1.298l0.124,0.316 c0,0,0.059-0.027,0.375-0.051c0.211-0.016,0.677,0.011,0.927,0.308l0.121,0.204l0.282-0.045c0.062-0.01,0.115-0.014,0.163-0.014 c0.571,0,1.036,0.465,1.036,1.036C222.36,21.798,221.895,22.263,221.323,22.263z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "219.781,26.726 219.484,27.22 219.482,27.221 218.974,28.05 219.834,28.05 220.565,26.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "220.858,24.968 220.269,25.922 221.003,25.917 221.524,24.971  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4D4E4E",
    points: "221.673,23.606 221.183,24.428 221.825,24.428 222.279,23.604  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.3caac1ee273183083105e816e4632528.svg";
export { ForwardRef as ReactComponent };